 import axios from 'axios'
 import store from './../store'

 const baseDomain = process.env.VUE_APP_API_BASE_URL
 const baseURL = `${baseDomain}/api`

 var axiosConnection = axios.create({
    baseURL,
   // headers: { Authorization: `Bearer ${store.state.jwtToken}` },
 })

  axiosConnection.interceptors.request.use((config) => {
    // We are importing store before it is populated.
    // We intercept the request and use the current apiKey
    config.headers = { Authorization: `Bearer ${store.state.jwtToken}` }
    return config
   })

   axiosConnection.interceptors.response.use(undefined, function (err) {
    return new Promise(function (resolve, reject) {
      if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
        this.$store.commit('LOGOUT')
      }
      throw err
    })
  })
  // axios.interceptors.request.use(function (config) {
  //   // Do something before request is sent
  //   return config
  // }, function (error) {
  //   // Do something with request error
  //   return Promise.reject(error)
  // })

 export default axiosConnection
